<template>
  <div>
    <div id="footer-section" class="ui middle aligned padded grid">
      <div class="ui sixteen wide column">
        <center>

          <h3 class="ui inverted header">{{ activeLandingPageContent.footerHeader }}</h3>
          <div
            class="ui inverted circular button"
            style="font-weight: normal; margin-top: 0.5em;"
            @click="registerInterest">
            <i class="envelope icon"/> &nbsp; {{ activeLandingPageContent.footerCTA }}
          </div>

        </center>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterCallToAction',
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {
    registerInterest() {
      if (typeof(this.$route.query.referral) === 'undefined') {
        if (this.$route.params.variant.toLowerCase() === 'symptom-tracker') {
          window.open(process.env.VUE_APP_SYMPTOMTRACKER_TYPEFORM + '?source=' + this.$route.params.variant, '_blank')
        }
        else {
          window.open(process.env.VUE_APP_CROWDSOURCE_TYPEFORM + '?source=' + this.$route.params.variant, '_blank')
        }
      } else {
        if (this.$route.params.variant.toLowerCase() === 'symptom-tracker') {
          window.open(process.env.VUE_APP_SYMPTOMTRACKER_TYPEFORM + '?source=' + this.$route.params.variant + '&referral=' + this.$route.query.referral, '_blank')
        } else {
          window.open(process.env.VUE_APP_CROWDSOURCE_TYPEFORM + '?source=' + this.$route.params.variant + '&referral=' + this.$route.query.referral, '_blank')
        }
      }
    }
  }
}
</script>

<style scoped>
  #footer-section {
    background: #00c3b6 center / cover;
    min-height: 40vh;
  }
</style>
